import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'ng2-app/http/clients/api';
import { ContractRequest } from 'ng2-app/services/contract-requests/contract-request.model';
import { environment } from '../../../environments/environment';
import { Contact } from 'ng2-app/models/dto/contact.model';

@Injectable({
  providedIn: 'root'
})
export class ContractRequestService {
  baseUrl = environment.API_URL;

  constructor(private http: ApiHttpClient) {
    this.baseUrl = environment.API_URL;
  }

  create(contractRequest: any): Observable<ContractRequest> {
    return this.http.post<any>(`${this.baseUrl}/deal/contract-request`, contractRequest);
  }

  send(contractRequest: any): Observable<ContractRequest> {
    return this.http.post<ContractRequest>(`${this.baseUrl}/deal/contract-request/send`, contractRequest);
  }

  update(contractRequest: any): Observable<ContractRequest> {
    return this.http.put<ContractRequest>(`${this.baseUrl}/deal/contract-request/${contractRequest.id}`, contractRequest);
  }

}
